import(/* webpackMode: "eager" */ "/codebuild/output/src967448291/src/apps/profile/src/app/error.tsx");
